import { get } from '../util/httpClient';

export const getVariable = async (key) => {
  const path = 'https://api.chatterfox.com/v1/variables';
  return get(path, null, { key });
};
